module.exports = __webpack_public_path__ + "img/fail.58cb9db.svg";